import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { authStore } from '../stores/AuthStore';
import '../styles/Layout.css';

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = observer(({ children }) => {
  const navigate = useNavigate();
  const [isCollapsed, setIsCollapsed] = useState(true);

  const handleLogout = () => {
    authStore.logout();
    navigate('/login');
  };

  const authUser = authStore.getAuthUser();
  return (
    <div className="layout">
      <nav className={`sidebar ${isCollapsed ? 'collapsed' : ''}`}>
        <img src='nav-logo.png' className='w-100' />
        <div className="sidebar-header">
          
          <button
            className="toggle-button"
            onClick={() => setIsCollapsed(!isCollapsed)}
            aria-label="Toggle sidebar"
            title={isCollapsed ? 'Expand' : 'Collapse'}
          >

            {!isCollapsed ? <i className="fa-solid fa-chevron-left"></i> : <i className="fa-solid fa-chevron-right"></i>}
          </button>
          <h2>Menu</h2>
        </div>
        <ul className="nav-menu">
          <li>
            <Link to="/calendar" className="nav-link">
              <i className="fa-regular fa-calendar-check"></i> {!isCollapsed ? " Calendar" : ""}
            </Link>
          </li>
          {/* <li>
            <Link to="/available" className="nav-link">
              <i className="fa-regular fa-calendar-days"></i> {!isCollapsed ? " Available" : ""}
            </Link>
          </li> */}
          {/* <li>
            <Link to="/bookings" className="nav-link">
              <i className="fa-solid fa-list"></i> {!isCollapsed ? " List View" : ""}
            </Link>
          </li> */}
          {/* <li>
            <Link to="/settings" className="nav-link">
              <i className="fa-solid fa-gear"></i> {!isCollapsed ? " Settings" : ""}
            </Link>
          </li> */}
        </ul>

        <div className="sidebar-footer">
          <div className="user-profile">
            <div className="user-avatar">
              {authUser?.name.charAt(0).toUpperCase()}
            </div>
            <div className="user-details">
              <p className="user-email">{authUser?.name}</p>
              <p className="user-role">{authUser?.role}</p>
            </div>
          </div>
          <button onClick={handleLogout} className="logout-button">
            {!isCollapsed ? "Logout" : "X"}
          </button>
        </div>
      </nav>

      <main className="main-content">{children}</main>
    </div>
  );
});
